window.fixPills = function (name) {
    $(name + ' a').click(function (e) {
        e.preventDefault();
        let clicked_element = $(this);
        clicked_element.find('> li').addClass('active-pill')
        clicked_element.children().addClass('active-pill');
        clicked_element.parent().children().each(function () {
            let current_element = $(this);
            if (current_element !== clicked_element) {
                current_element.attr('aria-selected', false);
                current_element.removeClass('active');
                current_element.removeClass('show');
            }
        })
    });
}
